/* unplugin-vue-components disabled */import script from "./DrawResultDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawResultDialog.vue?vue&type=script&setup=true&lang=js"

import "./DrawResultDialog.vue?vue&type=style&index=0&id=4b916dce&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b916dce"]])

export default __exports__